export const folderAPICategories = {
    networkRailStandards: 3,
    pageSize: 10,
    defaultPage: 1,
}